import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstanceJson from "../../../AxiosInstance/axiosInstanceJson";
import axiosInstance from "../../../AxiosInstance/axiosInstance";

export const createResult = createAsyncThunk(
  "Result/createResult",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `/v1/admin/result/create-result`,
        formData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getResult = createAsyncThunk(
  "Result/getResult",
  async (
    {
      id,
      status = "All",
      search = "",
      page = 1,
      limit = 10,
      startDate,
      endDate,
      paginate,
    },
    thunkAPI
  ) => {
    try {
      const { data } = await axiosInstance.get(`/v1/admin/result/get-result`, {
        params: {
          id,
          status,
          search,
          page,
          limit,
          startDate,
          endDate,
          paginate,
        },
      });
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Error occurred");
    }
  }
);

export const deleteResult = createAsyncThunk(
  "Result/deleteResult",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.put(
        `/v1/admin/result/delete-result/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const undoDeleteResult = createAsyncThunk(
  "Result/undoDeleteResult",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.put(
        `/v1/admin/result/undodelete-result/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getSingleResult = createAsyncThunk(
  "Result/getSingleResult",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.get(
        `/v1/admin/result/getSingle-result/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const updateResult = createAsyncThunk(
  "Result/updateResult",
  async ({ _id, formData }, thunkAPI) => {
    try {
      const response = await axiosInstance.put(
        `/v1/admin/result/update-result/${_id}`,
        formData
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getAllResultCategory = createAsyncThunk(
  "ResultCategory/getAllResultCategory",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.get(
        `/v1/admin/resultCategory/get-allresultCategory`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getClassrooms = createAsyncThunk(
  "Result/getClassrooms",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        "/v1/admin/result/get-classroom"
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
